import { FormattedMessage as FM } from "react-intl";

import useLangStore from "src/store/langStore";
import LangEs from "src/assets/apps/es.png";
import LangEn from "src/assets/apps/en.png";
import LangFr from "src/assets/apps/fr.png";
import LangPt from "src/assets/apps/pt.png";
import LangZh from "src/assets/apps/zh.png";
import Button from "componentsv2/button/Button";

function ContetSelectLan({ handleClose }) {
  const { changeLang, locale } = useLangStore();
  const handleLanguageChange = (lang) => {
    changeLang(lang);
    handleClose();
  };

  return (
    <div className="w-full flex justify-center items-center space-y-5 flex-col h-full relative">
      <h1 className="text-center text-2xl font-bold">
        <FM id="hotel.folio.guest.title-modal-select-lan" />
      </h1>

      <div className="grid grid-cols-2 gap-2">
        <Button color="white" onClick={() => handleLanguageChange("es")}>
          <img src={LangEs} alt="es" className="size-7 " />
          Español
        </Button>

        <Button color="white" onClick={() => handleLanguageChange("en")}>
          <img src={LangEn} alt="en" className="size-7" />
          English
        </Button>

        <Button color="white" onClick={() => handleLanguageChange("pt")}>
          <img src={LangPt} alt="pt" className="size-7" />
          Português
        </Button>

        <Button color="white" onClick={() => handleLanguageChange("fr")}>
          <img src={LangFr} alt="fr" className="size-7" />
          Français
        </Button>

        <div className="col-span-2 flex justify-center gap-4 mb-4">
          <Button color="white" onClick={() => handleLanguageChange("zh")}>
            <img src={LangZh} alt="zh" className="size-7" />
            國語
          </Button>
        </div>
      </div>
    </div>
  );
}

export default ContetSelectLan;
